import { useEffect } from 'react';
import { useMenuStore } from '../store/useMenuStore';
import { useAuthStore } from '@/modules/administracion/auth';

export const useMenu = () => {
  const { menuItems, isLoading, error, loadMenu, clearMenu } = useMenuStore();
  const { isAuthenticated } = useAuthStore();

  /**
   * Recarga el menú
   */
  const refreshMenu = () => {
    if (isAuthenticated) {
      loadMenu();
    }
  };

  // Cargar el menú cuando el componente se monta y el usuario está autenticado
  useEffect(() => {
    if (isAuthenticated) {
      loadMenu();
    } else {
      clearMenu();
    }
  }, [isAuthenticated]);

  return {
    menuItems,
    isLoading,
    error,
    refreshMenu,
  };
};

